import { Card, Icons, Stack, Text } from '@/theme/index';

export function MonitoringInfoSection() {
  return (
    <Card variant="outlined">
      <Text variant="h2" mb={2}>
        Monitoring reports is the best way to stay up to date on the information
        you need!
      </Text>
      <Stack alignItems="center">
        <Stack direction="row">
          <Icons.Check color="success" sx={{ marginRight: 1 }} />
          <Text variant="body1">
            Receive updates whenever we detect a change to a report
          </Text>
        </Stack>
        <Stack direction="row">
          <Icons.Check color="success" sx={{ marginRight: 1 }} />
          <Text variant="body1">Get alerts or a monthly recap via email</Text>
        </Stack>
        <Stack direction="row">
          <Icons.Check color="success" sx={{ marginRight: 1 }} />
          <Text variant="body1">Turn monitoring on or off at any time</Text>
        </Stack>
      </Stack>
    </Card>
  );
}
